import { Phone, Clock, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#171717] border-t border-white/10 py-16 px-6 lg:px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <img src="/logo.png" alt="Ultimate Warrior Junk and Plow Removal logo" className="h-24 w-auto mb-4" />
          <p className="text-neutral-400 text-sm leading-relaxed">Tough messes. Rugged solutions. Power washing, junk removal and snow plowing done right.</p>
        </div>
        <div>
          <h3 className="font-display uppercase text-xl tracking-wide mb-4">Contact</h3>
          <a data-testid="footer-phone-link" href="tel:+14165086931" className="flex items-center gap-3 text-neutral-300 hover:text-[#F59E0B] transition-colors duration-200 mb-3">
            <Phone className="w-4 h-4 text-[#F59E0B]" /> 416-508-6931
          </a>
          <p className="flex items-center gap-3 text-neutral-300">
            <Clock className="w-4 h-4 text-[#F59E0B]" /> 9am – 7pm, 7 days a week
          </p>
        </div>
        <div>
          <h3 className="font-display uppercase text-xl tracking-wide mb-4">Service Areas</h3>
          <p className="flex items-start gap-3 text-neutral-300">
            <MapPin className="w-4 h-4 text-[#F59E0B] mt-1 shrink-0" />
            <span>Etobicoke &bull; Mississauga &bull; Vaughan &bull; Brampton &bull; Toronto</span>
          </p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-neutral-500">
        <span>&copy; {new Date().getFullYear()} Ultimate Warrior Junk and Plow. All rights reserved.</span>
        <a data-testid="footer-admin-link" href="/admin/login" className="hover:text-[#F59E0B] transition-colors duration-200">Owner Login</a>
      </div>
    </footer>
  );
}
